import { AdminAccount, CreateAccount } from "../../account/models/AccountUser";
import { Page } from "../../shared/utils/http-utils";
import { jwtAuthAxios } from "../../shared/utils/network-utils";

export const AdminAccountApi = {
  page: async (pageSize: number, pageNumber: number) =>
    jwtAuthAxios().get<Page<AdminAccount>>(`/admin/accounts`, {
      params: { "page[size]": pageSize, "page[number]": pageNumber },
    }),

  createAccount: async (accountRequest: CreateAccount) => {
    return await jwtAuthAxios().post<AdminAccount>(
      `/admin/accounts`,
      accountRequest
    );
  },
};
